import { StatusStyle } from '../Status/StatusDot';
import { BackflowAssembly } from './types';

export const assemblyStatusStyle = (
  assembly: Pick<
    BackflowAssembly,
    'status' | 'replacedByAssembly' | 'removedByJobId'
  >
): StatusStyle => {
  if (assembly.replacedByAssembly) {
    return 'warning';
  }
  if (assembly.removedByJobId) {
    return 'error';
  }
  switch (assembly.status) {
    case 'ACTIVE':
      return 'success';
    case 'INACTIVE':
      return 'error';
    default:
      return 'default';
  }
};

export const assemblyStatusLabel = (
  assembly: Pick<
    BackflowAssembly,
    'status' | 'replacedByAssembly' | 'removedByJobId'
  >
): string => {
  if (assembly.replacedByAssembly) {
    return 'Replaced';
  }
  if (assembly.removedByJobId) {
    return 'Removed';
  }
  switch (assembly.status) {
    case 'ACTIVE':
      return 'Active';
    case 'INACTIVE':
      return 'Inactive';
    default:
      return assembly.status;
  }
};
